export default {
  projectDetail: {},
  checkBdUser: [],
  groupDetail: {},
}
